// 重构的数据更新
export default {
  // 更新门店的tab
  updateGlobalLoading(state, payload) {
    state.globalLoading = payload
  },
  updateCurrentTab(state, payload) {
    state.currentTab = payload
  },
  updateFilterOptions(state, payload = {}) {
    state.filterOptions = { ...state.filterOptions, ...payload }
  },
  updateFilterValues(state, payload = {}) {
    state.filterValue = { ...state.filterValue, ...payload }
  },
  updateListData(state, { currentTab, result = {} }) {
    const current = state.lists[currentTab]
    state.lists[currentTab] = { ...current, ...result }
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  updateSearchNot(state, payload) {
    state.searchNot = payload
  },
  setOtherPageArrStrategyTagId(state, payload) {
    state.otherPageArrStrategyTagId = payload
  },
  updateFilterSelectNum(state, payload) {
    state.filterSelectNum = payload
  },
  updateGeoErr(state, payload) {
    state.geoErr = payload
  },
  // 更新首页点击的卡片
  updateWorkbenchTagIdsAndCitys(state, payload) {
    // 把获取来的城市数据做映射处理
    const { tagIds, city = [] } = payload
    let cityMap = []
    if (city !== null) {
      cityMap = city.map(item => ({
        label: item.value,
        value: item.key,
      }))
    }
    state.workbenchTagIdsAndCity = {
      tagIds,
      city: cityMap,
    }
  },
  // 获取签约状态的数字
  updateCountByStatus(state, data) {
    state.countByStatus = data
  },
  // 获取加载时间的埋点
  updateTimeStamp(state, payload) {
    state.timestamp = payload
  },
  // 更新电话信息
  updatePhoneInfo(state, payload) {
    state.phoneInfo = payload
  },
  updateCompleteShopIds(state, payload) {
    state.unCompleteShopIds = payload
  },
  updateAllDataPop(state, payload) {
    state.showAllDataPop = payload
  },
  updateStrategyId(state, payload) {
    state.strategyId = payload
  },
  /** 更新油品params */
  updateProductParams(state, payload) {
    state.params = {
      ...state.params,
      ...payload,
    }
  },
  /** 更新实时数据 */
  updateRealTimeData(state, payload) {
    state.realTimeData.item = payload.sort((a, b) => a.order - b.order)
    state.loadings.price = false
  },
  updateMarketPriceData(state, payload) {
    state.marketPriceData.item = payload.data.sort((a, b) => a.order - b.order)
    state.marketPriceData.subregion = payload.subregion || 0
    state.loadings.pump = false
  },
  /** 更新历史价格 */
  updateHistoryPrice(state, payload) {
    state.historyPrice = payload
    state.loadings.priceChart = false
  },
  updatePriceLoading(state, payload) {
    state.loadings.price = payload
  },
  updatePumpLoading(state, payload) {
    state.loadings.pump = payload
  },
  updatePriceChartLoading(state, payload) {
    state.loadings.priceChart = payload
  },
  /** 更新经营数据 */
  updateOperationData(state, payload) {
    state.operationData.item = payload.sort((a, b) => a.order - b.order)
    state.loadings.operation = false
  },
  updateOperationLoading(state, payload) {
    state.loadings.operation = payload
  },
}
